<template>
  <div class="myCourses">
    <!-- <header-area></header-area> -->
    <banner-search></banner-search>
    <div class="content-holder">
      <mycourseCards></mycourseCards>
      <trendingCourses v-if="showTrendingCard && $store.getters.getItemsEnrolledByType('CO') != undefined && $store.getters.getItemsEnrolledByType('CO') != null && $store.getters.getItemsEnrolledByType('CO').length == 0"></trendingCourses>
       <infinite-loading  @infinite="infiniteHandler" spinner="waveDots" ref="infiniteLoader">
        <span slot ='no-results'></span>
        <span slot ='no-more'></span>
    </infinite-loading>
    </div>
    <!-- <footerArea></footerArea> -->
 </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import { EventBus } from '@/main.js'
import bannerSearch from '../home/bannerSearch.vue'
import courseWishlist from '@/components/wishList/courseWishList'
import courseCards from '../home/courseCards'
import mycourseCards from './mycourseCards'
import footerArea from '../common/footerArea'
import trendingCourses from '@/components/home/trendingCourses'

export default {
  name: 'wishlist',
  components: {
    bannerSearch,
    mycourseCards,
    courseCards,
    courseWishlist,
    footerArea,
    trendingCourses,
    InfiniteLoading
  },
  data () {
    return {
      showTrendingCard: false
    }
  },
  methods: {
    // infiniteHandler - starts lazy loading
    infiniteHandler ($state) {
      this.globalState = $state
      setTimeout(() => {
        this.showTrendingCard = true
        // this.showLibraryCard = true
        $state.loaded()
      }, 2000)
    },
    // handleScroll - handles scrolling
    handleScroll () {
      if (this.showTrendingCard) {
        setTimeout(() => {
          if (this.$refs.infiniteLoader !== undefined) {
            this.globalState.complete()
          }
        }, 2000)
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted () {
    EventBus.$emit('showNav', true)
  }
}
</script>






// WEBPACK FOOTER //
// src/components/myCourses/myCourses.vue?bc66a7f8